import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, HashRouter } from "react-router-dom";
import { Capacitor } from "@capacitor/core";
import { QueryClientProvider } from "@tanstack/react-query";

import App from "./App";
import { queryClient } from "./api/queryClient";
import { startAppLifecycle } from "./api/appLifecycle";
import { AuthProvider } from "./context/AuthContext";
import "./index.css";

// On native (Capacitor) the app is served from capacitor://localhost with no
// server to resolve deep paths on reload/cold-boot, so use HashRouter there.
// The web build is untouched: it keeps BrowserRouter (clean URLs + the GitHub
// Pages 404 shim). isNativePlatform() is false on the web, so this is a no-op
// there.
const Router = Capacitor.isNativePlatform() ? HashRouter : BrowserRouter;

startAppLifecycle();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Router>
      <QueryClientProvider client={queryClient}>
        <AuthProvider>
          <App />
        </AuthProvider>
      </QueryClientProvider>
    </Router>
  </React.StrictMode>,
);

// On native the navy MobileTopBar now sits behind the status bar, so render the
// status-bar text/icons in light (white) for contrast. Lazy-loaded so the web
// bundle never pulls the plugin in; no-op on the web.
if (Capacitor.isNativePlatform()) {
  import("@capacitor/status-bar")
    .then(({ StatusBar, Style }) => StatusBar.setStyle({ style: Style.Dark }))
    .catch(() => {});
}
